import { useEffect, useState } from "react";
import "./question.css";

const Question = ({ question, index, handleSubmit }) => {
  const [selectedAnswer, setAnswer] = useState(question?.selected_answer || "");

  useEffect(() => {
    if (selectedAnswer) {
      handleSubmit({
        question_id: question?.question_id,
        answer: selectedAnswer,
      });
    }

    return () => {};
  }, [selectedAnswer]);

  return (
    <div className="questionContainer">
      <p className="question">
        {index + 1}. {question.text}
      </p>
      <div className="optionsContainer">
        {question.options.map((option, i) => (
          <div key={i}>
            <button
              className={
                selectedAnswer == option ? "selected option" : "option"
              }
              onClick={() => setAnswer(option)}
            >
              {" "}
              <span /> {option}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Question;
